import React, { useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './admin.css';

import { clearSession } from '../utils/session';

const Topbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    clearSession();          // ✅ correct logout
    setDropdownOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <div className="navbar">
      <div className="navbar-icons">
        <div className="dropdown-wrapper">
          <FaUserCircle onClick={() => setDropdownOpen(!dropdownOpen)} />
          {dropdownOpen && (
            <div className="dropdown-menu">
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
